export const ACTIONS = {
  ORDERS_FETCH_START: 'ORDERS_FETCH_START',
  ORDERS_FETCH_SUCCESS: 'ORDERS_FETCH_SUCCESS',
  ORDERS_FETCH_FAILURE: 'ORDERS_FETCH_FAILURE',
  ORDERS_FETCH_RESET: 'ORDERS_FETCH_RESET',

  ORDERS_BY_SERVICE_FETCH_START: 'ORDERS_BY_SERVICE_FETCH_START',
  ORDERS_BY_SERVICE_FETCH_SUCCESS: 'ORDERS_BY_SERVICE_FETCH_SUCCESS',
  ORDERS_BY_SERVICE_FETCH_FAILURE: 'ORDERS_BY_SERVICE_FETCH_FAILURE',
  ORDERS_BY_SERVICE_FETCH_RESET: 'ORDERS_BY_SERVICE_FETCH_RESET',

  ORDER_FETCH_START: 'ORDER_FETCH_START',
  ORDER_FETCH_SUCCESS: 'ORDER_FETCH_SUCCESS',
  ORDER_FETCH_FAILURE: 'ORDER_FETCH_FAILURE',
  ORDER_FETCH_RESET: 'ORDER_FETCH_RESET',

  ORDER_CREATE_START: 'ORDER_CREATE_START',
  ORDER_CREATE_SUCCESS: 'ORDER_CREATE_SUCCESS',
  ORDER_CREATE_FAILURE: 'ORDER_CREATE_FAILURE',
  ORDER_CREATE_RESET: 'ORDER_CREATE_RESET',

  ORDER_UPDATE_START: 'ORDER_UPDATE_START',
  ORDER_UPDATE_SUCCESS: 'ORDER_UPDATE_SUCCESS',
  ORDER_UPDATE_FAILURE: 'ORDER_UPDATE_FAILURE',
  ORDER_UPDATE_RESET: 'ORDER_UPDATE_RESET',

  ORDER_DELETE_START: 'ORDER_DELETE_START',
  ORDER_DELETE_SUCCESS: 'ORDER_DELETE_SUCCESS',
  ORDER_DELETE_FAILURE: 'ORDER_DELETE_FAILURE',
  ORDER_DELETE_RESET: 'ORDER_DELETE_RESET',

  ORDER_STATUSES_FETCH_START: 'ORDER_STATUSES_FETCH_START',
  ORDER_STATUSES_FETCH_SUCCESS: 'ORDER_STATUSES_FETCH_SUCCESS',
  ORDER_STATUSES_FETCH_FAILURE: 'ORDER_STATUSES_FETCH_FAILURE',
  ORDER_STATUSES_FETCH_RESET: 'ORDER_STATUSES_FETCH_RESET',

  ORDER_COMPLETE_START: 'ORDER_COMPLETE_START',
  ORDER_COMPLETE_SUCCESS: 'ORDER_COMPLETE_SUCCESS',
  ORDER_COMPLETE_FAILURE: 'ORDER_COMPLETE_FAILURE',
  ORDER_COMPLETE_RESET: 'ORDER_COMPLETE_RESET',
  ORDER_AS_DELIVERED_START: 'ORDER_AS_DELIVERED_START',
  ORDER_AS_DELIVERED_SUCCESS: 'ORDER_AS_DELIVERED_SUCCESS',
  ORDER_AS_DELIVERED_FAILURE: 'ORDER_AS_DELIVERED_FAILURE',
  ORDER_AS_PAID_AND_DELIVERED_START: 'ORDER_AS_PAID_AND_DELIVERED_START',
  ORDER_AS_PAID_AND_DELIVERED_SUCCESS: 'ORDER_AS_PAID_AND_DELIVERED_SUCCESS',
  ORDER_AS_PAID_AND_DELIVERED_FAILURE: 'ORDER_AS_PAID_AND_DELIVERED_FAILURE',

  ORDER_CUSTOMER_APPROVAL_LINK_START: 'ORDER_CUSTOMER_APPROVAL_LINK_START',
  ORDER_CUSTOMER_APPROVAL_LINK_SUCCESS: 'ORDER_CUSTOMER_APPROVAL_LINK_SUCCESS',
  ORDER_CUSTOMER_APPROVAL_LINK_FAILURE: 'ORDER_CUSTOMER_APPROVAL_LINK_FAILURE',
  ORDER_CUSTOMER_APPROVAL_LINK_RESET: 'ORDER_CUSTOMER_APPROVAL_LINK_RESET',

  ORDER_PAYMENT_LINK_START: 'ORDER_PAYMENT_LINK_START',
  ORDER_PAYMENT_LINK_SUCCESS: 'ORDER_PAYMENT_LINK_SUCCESS',
  ORDER_PAYMENT_LINK_FAILURE: 'ORDER_PAYMENT_LINK_FAILURE',
  ORDER_PAYMENT_LINK_RESET: 'ORDER_PAYMENT_LINK_RESET',
};
